const customRender = (value, row, index, col) => {
  const obj = {
    children: value,
    attrs: {}
  }
  if (row.children) {
    obj.attrs.rowSpan = 1
    obj.attrs.colSpan = 1
  } else if (index === 0 && col.dataIndex === 'formulaName') {
    obj.attrs.rowSpan = row.childrenLength
    obj.attrs.colSpan = 3
  } else if (index === 0 && col.dataIndex === 'formulaCost') {
    obj.attrs.rowSpan = row.childrenLength
    // obj.attrs.colSpan = 3
  } else {
    obj.attrs.colSpan = 0
  }
  return obj
}

export const columns = [
  {
    title: '配方',
    dataIndex: 'productName',
    customRender,
    width: 160,
    fixed: 'left'
  },
  {
    title: '代码',
    dataIndex: 'formulaCode',
    width: 120,
    customRender,
    fixed: 'left'
  },
  {
    title: '版本',
    dataIndex: 'version',
    width: 40,
    checkable: true,
    customRender
  },
  {
    title: '营养师',
    dataIndex: 'staffName',
    width: 60,
    customRender
  },
  {
    title: '生成时间',
    dataIndex: 'createTime',
    width: 120,
    customRender
  },
  {
    title: '工厂',
    dataIndex: 'factoryName',
    customRender,
    scopedSlots: { customRender: 'factoryName' },
    width: 180
  },
  // {
  //   title: ' ',
  //   dataIndex: 'compensation',
  //   customRender(value) {
  //     const obj = {
  //       children: value,
  //       attrs: {}
  //     }
  //     obj.attrs.colSpan = 0
  //     return obj
  //   },
  //   fixed: 'left',
  //   width: 0
  // },
  {
    title: '原料',
    dataIndex: 'rawName',
    width: 110
  },
  {
    title: '用量(%)',
    dataIndex: 'percentage',
    checkable: true,
    checked: true,
    width: 110
  },
  {
    title: '用量(批次量)',
    dataIndex: 'uasge',
    checkable: true,
    width: 110
  },
  {
    title: '单位',
    dataIndex: 'unit',
    width: 110,
  },
  {
    title: '价格',
    dataIndex: 'price',
    scopedSlots: { customRender: 'line' },
    checkable: true,
    checked: true,
    width: 110
  },
  {
    title: '最小值',
    dataIndex: 'minValue',
    checkable: true,
    width: 110
  },
  {
    title: '最大值',
    dataIndex: 'maxValue',
    checkable: true,
    width: 110
  },
  {
    title: '适用下限',
    dataIndex: 'minApply',
    checkable: true,
    width: 110
  },
  {
    title: '适用上限',
    dataIndex: 'maxApply',
    checkable: true,
    width: 110
  },
  {
    title: '成本/单位',
    dataIndex: 'cost',
    checkable: true,
    width: 110
  },
  {
    title: '影子价格下限',
    dataIndex: 'minShadowPrice',
    checkable: false,
    width: 110
  },
  {
    title: '影子价格上限',
    dataIndex: 'maxShadowPrice',
    checkable: false,
    width: 110
  },

  {
    title: '极下限',
    dataIndex: 'minLimitValue',
    checkable: true,
    width: 110
  },
  {
    title: '极上限',
    dataIndex: 'maxLimitValue',
    checkable: true,
    width: 110
  },
  {
    title: '',
    dataIndex: 'compensation0'
  },
  {
    title: '配方成本',
    dataIndex: 'formulaCost',
    fixed: 'right',
    customRender,
    width: 80
  }
]
export const columns2 = [
  {
    title: '配方',
    dataIndex: 'productName',
    width: 160,
    fixed: 'left'
  },
  {
    title: '代码',
    dataIndex: 'formulaCode',
    width: 110,
    fixed: 'left'
  },
  {
    title: '版本',
    dataIndex: 'version',
    width: 40
  },
  {
    title: '配方师',
    dataIndex: 'staffName',
    width: 60
  },
  {
    title: '生成时间',
    dataIndex: 'createTime',
    width: 120
  },
  {
    title: '动物类型',
    dataIndex: 'animalTypeName',
    width: 60,
  },
  {
    title: '线路',
    dataIndex: 'lineName',
    width: 60,
  },
  {
    title: '配方分类',
    dataIndex: 'typeClassify',
    width: 60,
    scopedSlots: { customRender: 'typeClassify' },
  },
  {
    title: '工厂',
    dataIndex: 'factoryName',
    // customRender,
    scopedSlots: { customRender: 'factoryName' },
    width: 220
  },
  {
    title: ' ',
    dataIndex: 'compensation',
    // customRender(value) {
    //   const obj = {
    //     children: value,
    //     attrs: {}
    //   }
    //   obj.attrs.colSpan = 0
    //   return obj
    // },
    // fixed: 'left',
    // width: 0
  },
  {
    title: '原料',
    dataIndex: 'rawName',
    width: 110
  },
  {
    title: '用量(%)',
    dataIndex: 'percentage',
    checkable: true,
    checked: true,
    width: 110
  },
  {
    title: '用量(批次量)',
    dataIndex: 'uasge',
    checkable: true,
    checked: true,
    width: 110
  },
  {
    title: '单位',
    dataIndex: 'unit',
    width: 110,
    checked: true,
    checkable: true
  },
  {
    title: '价格',
    dataIndex: 'price',
    scopedSlots: { customRender: 'line' },
    checkable: true,
    checked: true,
    width: 110
  },
  {
    title: '最小值',
    dataIndex: 'minValue',
    checkable: true,
    width: 110
  },
  {
    title: '最大值',
    dataIndex: 'maxValue',
    checkable: true,
    width: 110
  },
  {
    title: '适用下限',
    dataIndex: 'minApply',
    checkable: true,
    width: 110
  },
  {
    title: '适用上限',
    dataIndex: 'maxApply',
    checkable: true,
    width: 110
  },
  {
    title: '成本/单位',
    dataIndex: 'cost',
    checkable: true,
    width: 110
  },
  {
    title: '影子价格下限',
    dataIndex: 'minShadowPrice',
    checkable: false,
    width: 110
  },
  {
    title: '影子价格上限',
    dataIndex: 'maxShadowPrice',
    checkable: false,
    width: 110
  },
  {
    title: '极下限',
    dataIndex: 'minLimitValue',
    checkable: true,
    width: 110
  },
  {
    title: '极上限',
    dataIndex: 'maxLimitValue',
    checkable: true,
    width: 110
  },
  {
    title: '',
    dataIndex: 'compensation0'
  },
  {
    title: '配方成本',
    dataIndex: 'formulaCost',
    fixed: 'right',
    width: 80
  }
]
export const columnsAdd = [
  {
    title: '原料名称',
    dataIndex: 'name'
  },
  {
    title: '代码',
    dataIndex: 'code'
  },
  {
    title: '类型',
    dataIndex: 'typeName'
  }
]
export const pagination = {
  total: 0,
  pageSize: 20,
  current: 1,
  showSizeChanger: true,
  showTotal: total => `共${total}条记录`
}
